export { default, type ContentCardProps } from './ContentCard';
